
import * as defaultImport from "@splunk/visualization-context/DataSourceContext";
export * from "@splunk/visualization-context/DataSourceContext";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
